import React, { useState, useEffect } from "react";

const Context = React.createContext("");

export function TokenContext(props) {

    const [token, set_token] = useState("")
    const [user_data, set_user_data] = useState({})
    const [app_data, set_app_data] = useState({})

    useEffect(() => {
        set_initial_data();
    }, [])

    const set_initial_data = () => {
        try {
            const tkData = localStorage.getItem("TOKEN");
            set_token(tkData);
            getProfileData(tkData);
        } catch (e) { }
    }

    const getProfileData = (token) => {
        // if (token !== undefined && token !== null && token !== "") {
        //     const AuthStudioUser = Promise.resolve(PostApiStudio(API_PATH_STUDIO.GetProfile, {}));
        //     AuthStudioUser.then((response) => {
        //         if (response.data.success) {
        //             set_app_data(response.data.data.app_result)
        //             set_user_data(response.data.data.studio_user)
        //         }
        //     })
        // }
    }

    const setToken = (token) => set_token(token);

    const setAppData = (user_data) => set_user_data(user_data)

    return <Context.Provider value={
        {
            ...{
                token,
                user_data,
                app_data,
            },
            setToken,
            setAppData,
            getProfileData
        }
    }>{props.children}</Context.Provider>;
}

export default Context;